import { render } from "./BorderInput.vue?vue&type=template&id=3398f044&scoped=true"
import script from "./BorderInput.vue?vue&type=script&lang=js"
export * from "./BorderInput.vue?vue&type=script&lang=js"

import "./BorderInput.vue?vue&type=style&index=0&id=3398f044&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3398f044"

export default script